import {Component, OnInit} from "@angular/core";
import {SiteWorkflowService} from "./site-workflow.service";
import {DartDealService} from "../../deal-list/dart-deals.service";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {DialogComponent} from "../../bootstrap-modal/dialog.component";
import {Observable} from "rxjs";

export interface DartCorrectionModel {
  projectId: string;
}

@Component({
  templateUrl: "./dart-correction-request.template.pug",
  providers: [SiteWorkflowService, DartDealService],
})
export class DartCorrectionRequestDialogComponent
  extends DialogComponent<DartCorrectionModel, void>
  implements DartCorrectionModel, OnInit {
  public projectId: string;
  public description: string;
  public error: Error;
  public sent: boolean;
  public deals: string[] = [];
  public disableDealSelection: boolean = false;
  public dealId: string;

  static showDialogModal(dialogService: DialogService, inputs: DartCorrectionModel): Observable<void> {
    return dialogService.addDialog(
      DartCorrectionRequestDialogComponent,
      inputs,
      {backdropColor: "rgba(0, 0, 0, 0.5)"},
    );
  }

  constructor(
    public dialogService: DialogService,
    public siteWorkflowService: SiteWorkflowService,
    private dartDealService: DartDealService,
  ) {
    super(dialogService);
  }

  loadData(): void {
    if (!this.projectId) return;
    this.dartDealService.getDealsFromProject(this.projectId)
      .then(({deals}) => {
        this.deals = deals;
        if (this.deals && this.deals.length === 1) {
          this.disableDealSelection = true;
          this.dealId = `${deals[0].dartDealId}.${deals[0].dealVersion}`;
        } else {
          this.disableDealSelection = false;
        }
      })
      .catch((error) => {
        this.error = error;
      });
  }

  ngOnInit() {
    this.loadData();
  }

  send(): void {
    this.error = null;
    this.sent = false;
    this.siteWorkflowService.sendDARTCorrectionRequest(this.description, this.projectId, this.dealId)
      .then(
        (success) => { this.sent = success; },
        (error) => { this.error = error; },
      );
  }

  cancel(): void {
    this.close();
  }
}
